var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrelloicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_126_45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6562 0H2.34375C1.04933 0 0 1.04933 0 2.34375V21.6562C0 22.9507 1.04933 24 2.34375 24H21.6562C22.9507 24 24 22.9507 24 21.6562V2.34375C24 1.04933 22.9507 0 21.6562 0Z",
    fill: "url(#paint0_linear_126_45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.755 3.12H14.685C14.0637 3.12 13.56 3.62368 13.56 4.245V12.495C13.56 13.1163 14.0637 13.62 14.685 13.62H19.755C20.3763 13.62 20.88 13.1163 20.88 12.495V4.245C20.88 3.62368 20.3763 3.12 19.755 3.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.315 3.12H4.245C3.62367 3.12 3.12 3.62368 3.12 4.245V18.495C3.12 19.1163 3.62367 19.62 4.245 19.62H9.315C9.93632 19.62 10.44 19.1163 10.44 18.495V4.245C10.44 3.62368 9.93632 3.12 9.315 3.12Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_126_45",
    x1: 1200,
    y1: 0,
    x2: 1200,
    y2: 2400,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0091E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0079BF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_126_45"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrelloicon);
export default __webpack_public_path__ + "static/media/trelloicon.ac558660a3cdbd42cb3bfb00530f716e.svg";
export { ForwardRef as ReactComponent };